import { apiClient } from '../../../../../services/apiClient'
import type {
  Tag,
  BuildingTagWithDetails,
  CreateUserBuildingTagDto,
  UpdateTagDto,
} from '@popety-io/types'

export const buildingTagsService = {
  createTag: async (tag: CreateUserBuildingTagDto): Promise<Tag> => {
    try {
      const response = await apiClient.post('/tags/building', tag)
      return response.data
    } catch (error) {
      console.error('Create building tag error:', error)
      throw error
    }
  },

  getAllTags: async (): Promise<BuildingTagWithDetails[]> => {
    try {
      const response = await apiClient.get('/tags/building/all')
      return response.data
    } catch (error) {
      console.error('Get all building tags error:', error)
      throw error
    }
  },

  getTagsByBuildingId: async (buildingId: string): Promise<Tag[]> => {
    try {
      const response = await apiClient.get(`/tags/building/${buildingId}`)
      return response.data
    } catch (error) {
      console.error('Get building tags by building ID error:', error)
      throw error
    }
  },

  updateTag: async (id: string, update: UpdateTagDto): Promise<Tag> => {
    try {
      const response = await apiClient.put(`/tags/building/${id}`, update)
      return response.data
    } catch (error) {
      console.error('Update building tag error:', error)
      throw error
    }
  },

  deleteTag: async (id: string): Promise<void> => {
    try {
      await apiClient.delete(`/tags/building/${id}`)
    } catch (error) {
      console.error('Delete building tag error:', error)
      throw error
    }
  },
}
